import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import IconButton from './IconButton';

const BiomeSummaryButton = ({title, styleName, onClick}) => (
  <div className="BiomeSummaryButton">
    <IconButton
      styleName={`BiomeSummaryButton--${styleName}`}
      onClick={onClick}
    >
      <p className={classNames(
        "BiomeSummaryButton__title",
        `BiomeSummaryButton--${styleName}-title`)}
      >
        {title}
      </p>
    </IconButton>
  </div>
);

BiomeSummaryButton.propTypes = {
  title: PropTypes.string.isRequired,
  styleName: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default BiomeSummaryButton;



// WEBPACK FOOTER //
// ./src/components/BiomeSummaryButton.js